export default {"src":"/_next/static/media/talkjs.10e39eef.svg","height":681,"width":600,"blurWidth":0,"blurHeight":0};